import React, { Component } from 'react'
import Axios from 'axios'
import './jobs-page.css'
import {ApplicationThankYou} from '../ApplicationThankYou/ApplicationThankYou'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { Helmet } from 'react-helmet'
import { baseUrl } from '../assets/Animations'

const JobsPage = () => {
    const [schools, setSchools] = React.useState([])
    const [selectedSchool, setSelectedSchool] = React.useState({})
    const [modal, setModal] = React.useState(false)
    const [thankyou, setThankYou] = React.useState(false)
    const [name, setName] = React.useState('')
    const [required, setRequired] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [email1, setEmail1] = React.useState('')
    const [email2, setEmail2] = React.useState('')
    const [schoolName, setSchoolName] = React.useState('')
    const [schoolBlurb, setSchoolBlurb] = React.useState('')
    const [schoolBlurb2, setSchoolBlurb2] = React.useState('')
    const [abbreviation, setAbbreviation] = React.useState('')
    const [schoolBackgroundImage, setSchoolBackgroundImage] = React.useState('')
    const [logoName, setLogoName] = React.useState('')
    const [website, setWebsite] = React.useState('')
    const [instruments, setInstruments] = React.useState([])
    const [instrumentsIPlay, setInstrumentsIPlay] = React.useState([])

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        Axios.get(`${baseUrl}/schools`, myHeader)
        .then((res) => {
            setSchools(res.data)
            setTheSchool(res.data)
        })
        .catch((err) => console.log(err))
        getInstruments()
    }, [])

    React.useEffect(() => {
        if(modal === true) {
            if(required === false) {
                document.getElementById('jobs-page-submit-btn').style.backgroundColor = "#888"
                document.getElementById('jobs-page-submit-btn').style.cursor = "default"
                document.getElementById('application-input-3').style.borderColor = "red"
                document.getElementById('email-warning').style.display = 'block'
            } else {
                document.getElementById('jobs-page-submit-btn').style.backgroundColor = "rgb(33, 156, 43)"
                document.getElementById('jobs-page-submit-btn').style.cursor = "pointer" 
                document.getElementById('application-input-3').style.borderColor = "rgb(33, 156, 43)"
                document.getElementById('email-warning').style.display = 'none'
            }
        }
    })

    const compareInstrumentNames = ( a, b ) => {
        if ( a.name < b.name ){
          return -1;
        }
        if ( a.name > b.name ){
          return 1;
        }
        return 0;
      }

    const getInstruments = () => {
        Axios.get(`${baseUrl}/inst`)
        .then((res) => {
            let myList = res.data
            myList.sort(compareInstrumentNames)
            setInstruments(myList)
        })
        .catch((err) => console.log(err))
    }

    const setTheSchool = (allSchoolsData) => {

        let url = window.location.href

        let trimmed = url.substring(8)

        let name = trimmed.split('.')[0]
        for(let i = 0; i < allSchoolsData.length; i++) {
            if(name === allSchoolsData[i].name.split(' ')[0].toLowerCase()) {
                setSelectedSchool(allSchoolsData[i])
                let schoolWebsite = allSchoolsData[i].logoUrl.substring(0, allSchoolsData[i].logoUrl.length - 9)
                setSchoolName(allSchoolsData[i].name)
                setAbbreviation(allSchoolsData[i].schoolAbbreviation)
                setLogoName(allSchoolsData[i].logoUrl)
                setEmail1(allSchoolsData[i].email)
                setEmail2(`apply@${allSchoolsData[i].email.split('@')[1]}`)
                setSchoolBlurb(`We offer in-home lessons in and around ${allSchoolsData[i].city}, ${allSchoolsData[i].state}. We are always looking for inspiring, knowledgable, and fun teachers to share the joy of music with their students.`)
                setSchoolBlurb2('As musicians ourselves, we designed this school around the idea of giving our fellow musicians a good job that can coexist with performances, recording sessions, and other artistic endeavors. We will work with you to create a schedule that allows you to balance your music career with your teaching career - connecting you with families nearby, and taking care of all the administration so you can focus on the music.')
                setWebsite(schoolWebsite)
            }
        }
    }

    const logChange = () => {
        let emailValue = document.getElementById('application-input-3').value
        if(emailValue !== '') {
            setRequired(true)
        } else {
            setRequired(false)
        }
    }

    const toggleModal = () => {
        if(modal === false) {
            setModal(true)
        } else {
            setModal(false)
            setRequired(false)
        }
    }
    const closeModal = (id) => {
        if(id === 'jobs-page-modal-wrapper') {
            toggleModal()
        }
    }
    const addAnInstrument = (id) => {
        for(let i = 0; i < instruments.length; i++) {
            if(instruments[i].id === id) {
                setInstrumentsIPlay((prev) => [...prev, instruments[i]])
                document.getElementById('instrument-selector__id').value = ''
            }
        }
    }
    const removeAnInstrument = (theIndex) => {
        let tempList = instrumentsIPlay
        tempList.splice(theIndex, 1)
        setInstrumentsIPlay([...tempList])
    }
    const submitApplication = () => {
        setLoading(true)
        if(required === false) {
            return
        } else {
            let allAreaCheckBoxes = document.getElementsByClassName('area-checkbox')
            let areasTeachIn = ''
            for(let i = 0; i < allAreaCheckBoxes.length; i++) {
                if(allAreaCheckBoxes[i].checked) {
                    areasTeachIn = areasTeachIn + ' ' + allAreaCheckBoxes[i].value
                }
            }
            let  application = {}
            for(let i = 1; i < 14; i++) {
                if(i === 8) {
                    application['key8app'] = ''
                } else {
                    let num = i
                    let key = 'key' + num + 'app'
                    application[key] = document.getElementById('application-input-' + num).value
                }
            }
            application['key13app'] = instrumentsIPlay
            application['key22app'] = areasTeachIn
            application['key14app'] = `${schoolName}`
            application['key15app'] = `${email1}`
            application['key16app'] = `${email2}`
            application['id'] = Math.random().toString(16).slice(2)
    
            application['key17app'] = document.getElementById('background-check').checked
            application['key18app'] = document.getElementById('vehicle-check').checked
            application['key19app'] = document.getElementById('license-check').checked
            application['key20app'] = document.getElementById('application-input-13').value
            application['key21app'] = document.getElementById('references').value
            
            setName(application['key1app'])
            
            Axios.put(`${baseUrl}/newteacherapplication`, {
                application: application
            })
            .then(response => {
                if(response.status === 200) {
                    toggleModal()
                    setLoading(false)
                    setThankYou(true)
                } else {
                    setLoading(false)
                    alert('Sorry! There seems to be a problem. Try submitting your application again.')
                }
            })
            .catch(e => {
                console.log('Oops ' + e)
                console.log(e)
            })
            Axios.post(`${baseUrl}/applicationhiringcard`, {
                application: application,
            })
            .then(response => {})
            .catch(e => {
                console.log('Oops ' + e)
                console.log(e)
            })
        }
    }

    if(modal === false) {
        return (
        <>
            <Helmet>
                <title>{`${schoolName} Careers`}</title>
            </Helmet>
            <div>
                {loading && <NewLoadingScreen message={"Submitting application..."} logo={logoName} />}
                <div className="jobs-page" style={{backgroundImage: `url(./${abbreviation}.jpg)`}}>
                    <ApplicationThankYou thankyou={thankyou} name={name} website={website}/>
                    <div className="jobs-page-logo" style={{backgroundImage: `url(${logoName})`}}></div>
                    <div className="jobs-page-headline">
                        Share the joy of music while pursuing your career at {schoolName}!
                    </div>
                    <div className="jobs-page-apply-button" onClick={() => toggleModal()}>Apply Now</div>
                    <div className="scroll-down-wrapper">
                        <div className="jobs-page-scroll-down-icon"></div>
                    </div>
                </div>
                <div>
                    <div className="jobs-page-description">
                        <div className="jobs-page-blurb-title">Welcome to <br></br> {schoolName}</div>
                        <div className="jobs-page-blurb">
                        {schoolBlurb} <br></br><br></br> {schoolBlurb2}
                        </div>
                    </div>
                </div>
            </div>
        </>
        )  
    } else {
        return (
        <>
            <Helmet>
                <title>{`${schoolName} Careers`}</title>
            </Helmet>
            <div>
                {loading && <NewLoadingScreen message={"Submitting application..."} />}
                <div className="jobs-page" style={{backgroundImage: `url(./${abbreviation}.jpg)`}}>
                    <ApplicationThankYou thankyou={thankyou} name={name}/>
                    <div className="jobs-page-logo" style={{backgroundImage: `url(${logoName})`}}></div>
                    <div className="jobs-page-headline">
                        Share the joy of music while persuing your career at {schoolName}!
                    </div>
                    <div className="jobs-page-apply-button" onClick={() => toggleModal()}>Apply Now</div>
                    <div className="scroll-down-wrapper">
                        <div className="jobs-page-scroll-down-icon"></div>
                    </div>
                </div>
                <div>
                    <div className="jobs-page-description">
                        <div className="jobs-page-blurb-title">Welcome to <br></br> {schoolName}</div>
                        <div className="jobs-page-blurb">
                        {schoolBlurb} <br></br><br></br> {schoolBlurb2} 
                        </div>
                    </div>
                </div>


    {/* --------------------APPLICATION-MODAL--------------------- */}

                <div className="jobs-page-modal-wrapper" id="jobs-page-modal-wrapper" onClick={(e) => closeModal(e.target.id)}>
                    <div className="jobs-page-application-modal">
                        <div className="jobs-page-modal-x-wrapper">
                            <div className="jobs-page-modal-x" onClick={() => toggleModal()}>x</div>
                        </div>
                        <div className="application-form-title">
                            Teacher Application
                        </div>
                        <div className="input-row">
                            <div className="input-name-wrapper">
                                <input className="jobs-page-inputs short" id="application-input-1" name="first-name" required/>
                                <label htmlFor="first-name" className="ani-label-name">
                                    <span className="content-name">First Name</span>
                                </label>
                            </div>
                            <div className="input-last-name-wrapper">
                                <input className="jobs-page-inputs short" id="application-input-2" name="last-name" required/>
                                <label htmlFor="last-name" className="ani-label-name">
                                    <span className="content-name">Last Name</span>
                                </label>
                            </div>
                        </div>
                        <div className="input-row">
                            <div className="input-name-wrapper">
                                <input className="jobs-page-inputs short" id="application-input-3" onChange={() => logChange()} name="email-address" required/>
                                <label htmlFor="email-address" className="ani-label-name">
                                    <span className="content-name">Email Address*</span>
                                </label>
                            </div>
                            <div className="input-last-name-wrapper">
                                <input className="jobs-page-inputs short" id="application-input-4" name="phone-number" required/>
                                <label htmlFor="phone-number" className="ani-label-name">
                                    <span className="content-name">Phone Number</span>
                                </label>
                            </div>
                        </div>
                        <div className="input-row">
                        <div className="input-center-wrapper">
                                <input className="jobs-page-inputs short" id="application-input-5" name="current-city" required/>
                                <label htmlFor="current-city" className="ani-label-name">
                                    <span className="content-name center-name">Current City of Residence</span>
                                </label>
                            </div>
                        </div>
                        <div className="jobs-page-input-labels">Instrument(s) you teach</div>
                        <div className="app-checkbox-wrapper">
                            <select className='school-edit-town__new-town-dropdown' id="instrument-selector__id" onChange={(e) => addAnInstrument(e.target.value)}>
                                <option value='' default>+ Add An Instrument</option>
                                {instruments.map((inst) => <option key={inst.id} value={inst.id}>{inst.name}</option>)}
                            </select>
                        </div>
                        <div className='inst-chip__wrapper'>
                            {instrumentsIPlay.map((inst, index) => (
                                <div className='inst-box__wrapper'>
                                    <div className='inst-box__remove-x' onClick={() => removeAnInstrument(index)}>x</div>
                                    <div className='inst-box__inst-name'>{inst.name}</div>
                                </div>
                            ))}
                        </div>
                        {/* <div className="app-checkbox-wrapper">
                            {instruments.map((inst, index) => (
                                <div className="each-check-wrapper">
                                    <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name={`inst${index}`} value={inst.name}></input>
                                    <label htmlFor={`inst${index}`}>{inst.name}</label>
                                </div> 
                            ))}
                        </div> */}
                        {/* <div className="app-checkbox-wrapper">
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst1" value="Piano"></input>
                            <label htmlFor="inst1"> Piano</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst2" value="Voice"></input>
                            <label htmlFor="inst2"> Voice</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst3" value="Guitar"></input>
                            <label htmlFor="inst3"> Guitar</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst4" value="Violin"></input>
                            <label htmlFor="inst4"> Violin</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst5" value="Viola"></input>
                            <label htmlFor="inst5"> Viola</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst6" value="Cello"></input>
                            <label htmlFor="inst6"> Cello</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst7" value="Bass"></input>
                            <label htmlFor="inst7"> Bass</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst8" value="Trumpet"></input>
                            <label htmlFor="inst8"> Trumpet</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst9" value="French Horn"></input>
                            <label htmlFor="inst9"> French Horn</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst10" value="Trombone"></input>
                            <label htmlFor="inst10"> Trombone</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst11" value="Baritone"></input>
                            <label htmlFor="inst11"> Baritone</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst12" value="Euphonium"></input>
                            <label htmlFor="inst12"> Euphonium</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst13" value="Tuba"></input>
                            <label htmlFor="inst13"> Tuba</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst14" value="All Brass"></input>
                            <label htmlFor="inst14"> All Brass</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst15" value="Ukulele"></input>
                            <label htmlFor="inst15"> Ukulele</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst16" value="Mandolin"></input>
                            <label htmlFor="inst16"> Mandolin</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst17" value="Flute"></input>
                            <label htmlFor="inst17"> Flute</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst18" value="Clarinet"></input>
                            <label htmlFor="inst18"> Clarinet</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst19" value="Saxophone"></input>
                            <label htmlFor="inst19"> Saxophone</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst20" value="Oboe"></input>
                            <label htmlFor="inst20"> Oboe</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst21" value="Bassoon"></input>
                            <label htmlFor="inst21"> Bassoon</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst22" value="Drums"></input>
                            <label htmlFor="inst22"> Drums</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst23" value="Percussion"></input>
                            <label htmlFor="inst23"> Percussion</label>
                            </div>
                            <div className="each-check-wrapper"> <input type="checkbox" id="inst-checkbox" className="inst-checkbox" name="inst24" value="Vibraphone"></input>
                            <label htmlFor="inst24"> Vibraphone</label>
                            </div>
                        </div> */}
                        {selectedSchool.towns.length > 1 &&
                        <div>
                            <div className="jobs-page-input-labels">Area(s) you will teach in</div>
                            <div className="app-checkbox-wrapper">
                                {selectedSchool.towns.map((town, index) => (
                                    <div key={town.id} className="each-check-wrapper"> 
                                        <input type="checkbox" id="area-checkbox" className="area-checkbox" name={`area${index}`} value={town.name}></input>
                                        <label htmlFor={`area${index}`}>{town.name}</label>
                                    </div>
                                ))}
                            </div>
                        </div>}
                        <div></div>
                        <div className="jobs-page-input-labels">How many years of teaching experience?</div>
                        <select className="jobs-page-select-bars"  id="application-input-6" >
                            <option default>-</option>
                            <option value="1-2">1-2</option>
                            <option value="2-3">2-3</option>
                            <option value="3-5">3-5</option>
                            <option value="5-10">5-10</option>
                            <option value="10+">10+</option>
                        </select>
                        <div className="jobs-page-input-labels">How many years do you forsee staying with us?</div>
                        <select className="jobs-page-select-bars"  id="application-input-7" >
                            <option default>-</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5+</option>
                        </select>
                        {/* <div className="jobs-page-input-labels">Mile Radius</div> */}
                        {/* <select className="jobs-page-select-bars"  id="application-input-8" >
                            <option value='' default>-</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                        </select> */}
                        <div className="jobs-page-input-labels">Ideal Number of Students</div>
                        <select className="jobs-page-select-bars"  id="application-input-9" >
                            <option default>-</option>
                            <option>1-10</option>
                            <option>10-20</option>
                            <option>20+</option>
                        </select>
                        <div className="background-vehicle-wrapper">
                            <div className="each-check-wrapper background-checks">
                                <input type="checkbox" className="background-checkboxes" id="background-check" name="background-check" value="yes"/>
                                <label htmlFor="background-check"> I am willing to undergo a background check, in accordance with local law/regulations.</label>
                            </div>
                            <div className="each-check-wrapper background-checks">
                                <input type="checkbox" className="background-checkboxes" id="vehicle-check" name="vehicle" value="yes" />
                                <label htmlFor="vehicle">I have a reliable vehicle.</label>
                            </div>
                            <div className="each-check-wrapper background-checks">
                                <input type="checkbox" className="background-checkboxes" id="license-check" name="license" value="yes" />
                                <label htmlFor="license">I have a valid driver's license.</label>
                            </div>
                        </div>
                        <div className="jobs-page-input-labels">Cover Letter: <span className="input-labels-small">Please explain why you think you'd be a good fit for our school</span></div>
                        <textarea className="jobs-page-textareas"  id="application-input-10" />
                        <div className="jobs-page-input-labels">Please list your education <span className="input-labels-small">(feel free to include education that is in-progress)</span></div>
                        <textarea className="jobs-page-textareas" placeholder="Institutions, degrees, and graduation dates..."  id="application-input-11" />
                        <div className="jobs-page-input-labels">Relevant Work Experience</div>
                        <textarea className="jobs-page-textareas"  id="application-input-12" />
                        <div className="jobs-page-input-labels">Links to video or audio recordings of you playing</div>
                        <textarea className="jobs-page-textareas"  id="application-input-13" />
                        <div className="jobs-page-input-labels">References: <span className="input-labels-small">Please list 2-3 professional references</span></div>
                        <textarea className="jobs-page-textareas" placeholder="Name, phone number, email address and relationship to you"  id="references" />
                        <div className="email-warning" id="email-warning">Please include your email address!</div>
                        <div className="jobs-page-submit-btn" id="jobs-page-submit-btn" onClick={() => submitApplication()}>SUBMIT</div>
                        <div className="spacer"></div>
                    </div>
                </div>

            </div>
        </>
        )
    }
}

export default JobsPage